import { PaginationMetadata } from '@execonline-inc/resource';
import { observer } from 'mobx-react';
import * as React from 'react';
import Next from './Next';
import Previous from './Previous';
import { T, TranslationsContext, translation } from '../../Translations';
import { emptyFragment } from '../../EmptyFragment';
import { whenNotOnFirstPage, whenNotOnLastPage } from './pagination';

export type PageFn = (page: number) => void;

interface Props {
  metadata: PaginationMetadata;
  pageFn: PageFn;
}

const Pagination: React.FC<Props> = ({ metadata, pageFn }) => {
  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <div className="flex items-center md:justify-between md:py-3">
          <div className="flex flex-col md:flex-row flex-1 items-center justify-between">
            <p className="text-sm text-gray-700">
              <T
                kind="Page {{currentPage}} of {{pageCount}}"
                currentPage={metadata.currentPage}
                pageCount={metadata.pageCount}
              />
            </p>
            <div className="flex">
              <nav
                className="isolate inline-flex space-x-px"
                aria-label={translation('Pagination')(ts)}
              >
                {whenNotOnFirstPage(metadata)
                  .map((metadata) => <Previous metadata={metadata} pageFn={pageFn} />)
                  .getOrElse(emptyFragment)}
                {whenNotOnLastPage(metadata)
                  .map((metadata) => <Next metadata={metadata} pageFn={pageFn} />)
                  .getOrElse(emptyFragment)}
              </nav>
            </div>
          </div>
        </div>
      )}
    </TranslationsContext.Consumer>
  );
};

export default observer(Pagination);
